<div>
  <h2
    mat-dialog-title
    style="color: white"
    class="title-text theme-background-color mb-4">
    Choose Expiration
  </h2>
  <mat-dialog-content class="mat-typography">
    <div class="row">
      <div class="col-md-12" style="position: relative; top: 14px">
        <div class="form-group">
          <label for="message">
            {{ data.message }} <span class="text-danger">*</span></label
          >
        </div>
      </div>
    </div>
    <div>
      <input
        [owlDateTime]="dt1"
        [owlDateTimeTrigger]="dt1"
        class="form-control"
        placeholder="Enter expiration date"
        [formControl]="selectedDate"
        [min]="minDate"
        [max]="maxDate"
        [ngClass]="{
          'is-invalid': selectedDate.invalid && selectedDate.touched,
        }" />
      <owl-date-time [pickerType]="'calendar'" #dt1></owl-date-time>
      <span class="error invalid-feedback text-danger">
        Please select a valid expiration date
      </span>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions style="gap: 4px" class="flex-d" align="end">
    <button
      class="btn btn-secondary"
      [mat-dialog-close]="false"
      (click)="onCancel()">
      Cancel
    </button>
    <button
      class="btn btn-primary custom-button"
      [mat-dialog-close]="true"
      (click)="onConfirm()"
      [disabled]="selectedDate.invalid">
      Generate
    </button>
  </mat-dialog-actions>
</div>
